module.exports = __webpack_public_path__ + "img/opet-infographic-05.20b57bf1.jpg";